import { createFileRoute } from '@tanstack/react-router';

import VoiceSalesCampaignsPage, { type CampaignsSearch } from '../../views/dashboard-voice-sales/CampaignsPage';

const CAMPAIGN_SORT_FIELDS = new Set(['campaign', 'status', 'dailyLimit', 'created']);

function stringSearchValue(value: unknown): string | undefined {
  if (typeof value === 'string' && value) return value;
  if (typeof value === 'number' && Number.isFinite(value)) return String(value);
  return undefined;
}

export const Route = createFileRoute('/dashboard/voice-sales/campaigns')({
  validateSearch: (input: Record<string, unknown>): CampaignsSearch => ({
    q: stringSearchValue(input.q),
    status: stringSearchValue(input.status),
    mode: stringSearchValue(input.mode),
    sortingField:
      typeof input.sortingField === 'string' && CAMPAIGN_SORT_FIELDS.has(input.sortingField)
        ? (input.sortingField as CampaignsSearch['sortingField'])
        : undefined,
    sortDirection: input.sortDirection === 'asc' || input.sortDirection === 'desc' ? input.sortDirection : undefined,
    page: Number.isInteger(Number(input.page)) && Number(input.page) > 1 ? Number(input.page) : undefined,
  }),
  component: VoiceSalesCampaignsPage,
});
